// Cave84 — Accent-insensitive text matching for search boxes.
// "beze" must match "Bèze", "chateau" must match "Château", "muller" must match "Müller", etc.

const COMBINING_MARKS = /[\u0300-\u036f]/g;

/**
 * Lowercases and strips diacritics. Also expands characters that NFD does not
 * decompose (ß, œ, æ, ø, đ, ł). Does NOT strip punctuation, so it is safe to
 * use for plain substring matching.
 */
export function foldSearch(s: string | null | undefined): string {
  if (!s) return '';
  return s
    .normalize('NFD')
    .replace(COMBINING_MARKS, '')
    .toLowerCase()
    .replace(/ß/g, 'ss')
    .replace(/œ/g, 'oe')
    .replace(/æ/g, 'ae')
    .replace(/ø/g, 'o')
    .replace(/đ/g, 'd')
    .replace(/ł/g, 'l');
}

/** True when `haystack` contains `needle`, ignoring case and diacritics. */
export function matchesSearch(haystack: string, needle: string): boolean {
  return foldSearch(haystack).includes(foldSearch(needle));
}
